import Vue from 'vue';
export default Vue.extend({
    name: 'spotFolderItem',
    props: {
        name: {
            type: String,
            required: true
        },
        id: {
            type: Number,
            required: true
        },
        opened: {
            type: Boolean,
            required: true
        },
        isFolder: {
            type: Boolean,
            required: true
        },
        locked: {
            type: Boolean,
            required: true
        },
        empty: {
            type: Boolean,
            required: true
        },
        selected: {
            type: Boolean,
            required: true
        },
        defaultFolder: {
            type: Boolean,
            required: true
        },
        folderIDToRename: {
            required: true
        },
        letLockFolder: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        newFolderName: '',
        folderNameEdit: false
    }),
    watch: {
        folderIDToRename(v) {
            const vm = this;
            if (v === vm.id)
                vm.folderNameEdit = true;
        }
    },
    methods: {
        handleApplyFolderNameEdit(name) {
            const vm = this;
            if (name) {
                vm.$emit('onFolderRename', name);
            }
            else
                vm.$emit('onCancelRename');
            vm.newFolderName = '';
            vm.folderNameEdit = false;
        }
    }
});
